import { FC, useMemo } from "react";

import { useBreakpoint } from "../../../hooks/useBreakpoint";

import { socialLinks } from "./SocialRow.const";

const SocialRow: FC = () => {
	const chartSize = useBreakpoint();

	const imageSize = useMemo(() => {
		switch (chartSize) {
			case "xs":
			case "sm":
				return 30;
			case "lg":
			case "md":
				return 25;
			default:
				return 20;
		}
	}, [chartSize]);

	return (
		<div className="flex flex-col items-center">
			<div className="flex lg:w-full w-3/4 lg:mx-0 mx-auto flex-end sm:justify-start gap-4">
				{socialLinks.map((socialLink) => {
					return (
						<a key={socialLink.link} href={socialLink.link} target="_blank" rel="noreferrer" className="pr-2 hover:bg-slate-100 rounded-md">
							<socialLink.logo className="text-white" width={imageSize} />
						</a>
					);
				})}
			</div>
		</div>
	);
};

export { SocialRow };
